import React, { FC, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarItemNext, SidebarItemNextProps, Text } from '@wix/design-system';
import { mediaManagerSideBarClick } from '@wix/bi-logger-media-data/v2';
import { Source } from '../../../constants/Source';
import { bi } from '../../../services/loggers/bi';
import { useMMGRSettings } from '../../../utils/hoc/withMMGRSettings';

type SideBarLinkProps = SidebarItemNextProps & {
  source: Source;
};

export const SideBarLink: FC<SideBarLinkProps> = ({ source, ...props }) => {
  const { mmgrSettings: { isUIAlignmentsEnabled } } = useMMGRSettings();

  const onClick = useCallback(() => bi.logger().report(mediaManagerSideBarClick({ target: source })), [source]);

  return isUIAlignmentsEnabled ? (
    <SidebarItemNext dataHook="sidebar-link" {...props} itemKey={source} onClick={onClick} as={NavLink}>
      <Text weight='thin' size='small'>{props.children}</Text>
    </SidebarItemNext>
  ) : (
    <SidebarItemNext dataHook="sidebar-link" {...props} itemKey={source} onClick={onClick} as={NavLink} />
  );
};
